/**
 *
 * @param component
 * @returns {{methods: {dismiss(): void}}}
 */
export function modalPageDecorator(component) {
  return {
    ...component,
    methods: {
      dismiss() {
        this.$router.back();
      },
      ...(component.methods || {}),
    },
  }
}

/**
 *
 */
export default modalPageDecorator({
  render(h) {
    return (
      <div class="fixed w-full h-full top-0 left-0 overflow-y-auto z-50">
        <div class="fixed w-full h-full bg-gray-900 opacity-50" onClick={this.dismiss}></div>
        { this.$slots.default }
      </div>
    )
  }
})